import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system'

import spacing from 'airship/design-system/theme/foundations/space'

import colors from '../foundations/colors'
import typography from '../foundations/typography'

const baseStyle = defineStyle({
  direction: 'horizontal',
  alignItems: ['middle', 'center'],
  resize: 'both',
  itemSpacing: spacing['6xs'],
})

const primary = defineStyle({
  color: colors.text.brand,
  _hover: {
    color: colors.text['brand-hover'],
    textDecoration: 'underline',
  },
})

const secondary = defineStyle({
  color: colors.text.secondary,
  _hover: {
    color: colors.text['secondary-hover'],
    textDecoration: 'underline',
  },
})

const sizes = {
  sm: defineStyle({
    ...typography.textStyles.body.small,
  }),
  md: defineStyle({
    ...typography.textStyles.body.medium,
  }),
  lg: defineStyle({
    ...typography.textStyles.body.large,
  }),
}

const linkTheme = defineStyleConfig({
  baseStyle,
  sizes,
  variants: {
    primary,
    secondary,
  },
  defaultProps: {
    variant: 'primary',
  },
})

export default linkTheme
